import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-view" }

import Map from '@/components/map/Map.vue';
    import { landPlotStore } from '@/store/modules/LandPLot';
    import { onBeforeMount } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MainView',
  setup(__props) {

    onBeforeMount(async () => {
        await Promise.all([landPlotStore.LOAD_LAND_PLOTS()]);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Map)
  ]))
}
}

})